import { useEffect, useState, useRef } from 'react';

const runtimeConfig = window.__CONFIG__ || {};
const environment =
  runtimeConfig.REACT_APP_ENVIRONMENT ||
  process.env.REACT_APP_ENVIRONMENT ||
  'development';

const API_BASE_URL =
  environment === 'production'
    ? (runtimeConfig.REACT_APP_API_BASE_URL_PROD ||
       process.env.REACT_APP_API_BASE_URL_PROD ||
       '')
    : (runtimeConfig.REACT_APP_API_BASE_URL_DEV ||
       process.env.REACT_APP_API_BASE_URL_DEV ||
       '');

function useReadingTracker(contentId, contentType, userId) {
  const [activeTime, setActiveTime] = useState(0);
  const activeTimeRef = useRef(0);
  const intervalRef = useRef(null);

  const sendPayload = () => {
    if (activeTimeRef.current > 0) {
      const payload = JSON.stringify({
        content_id: contentId,
        content_type: contentType,
        active_time: activeTimeRef.current,
        timestamp: new Date().toISOString(),
        uid: userId
      });
      fetch(`${API_BASE_URL}/track/readtime`, {
        method: 'POST',
        body: payload,
        headers: { 'Content-Type': 'application/json' },
        keepalive: true
      });
    }
  };

  const handleVisibilityChange = () => {
    if (document.visibilityState === 'hidden') {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      sendPayload();
      activeTimeRef.current = 0;
      setActiveTime(0);
    } else if (document.visibilityState === 'visible' && !intervalRef.current) {
      intervalRef.current = setInterval(() => {
        activeTimeRef.current += 1;
        setActiveTime(activeTimeRef.current);
      }, 1000);
    }
  };

  useEffect(() => {
    if (document.visibilityState === 'visible') {
      intervalRef.current = setInterval(() => {
        activeTimeRef.current += 1;
        setActiveTime(activeTimeRef.current);
      }, 1000);
    }
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      sendPayload();
      activeTimeRef.current = 0;
      setActiveTime(0);
    };
  }, []);

  return activeTime;
}

export default useReadingTracker;
